"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SolucionesDeSeguridadIntegral() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const services = [{
    number: "01",
    title: "Vigilancia y Seguridad Física",
    description: "Despliegue de guardias de seguridad altamente capacitados para la protección de activos industriales, comerciales y residenciales. Disciplina y vigilancia constante bajo protocolos estrictos.",
    techniques: "CONTROL DE ACCESOS · RONDINES · PROTECCIÓN PERIMETRAL",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/seguridad_fisica_poseidon.png",
    alt: "Guardia de seguridad profesional en puesto de vigilancia"
  }, {
    number: "02",
    title: "Monitoreo de Videovigilancia",
    description: "Centro de control avanzado con tecnología de punta para la supervisión remota 24/7. Detección temprana de anomalías y respuesta inmediata ante cualquier incidente detectado.",
    techniques: "CCTV · ANALÍTICA DE VIDEO · RESPUESTA REMOTA",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/monitoreo_cctv_poseidon.png",
    alt: "Centro de monitoreo con múltiples pantallas de seguridad"
  }, {
    number: "03",
    title: "Rastreo y Logística GPS",
    description: "Seguimiento vehicular en tiempo real con geocercas y alertas de desviación. Optimizamos la seguridad de sus traslados y la integridad de sus mercancías en tránsito.",
    techniques: "GEOCERCAS · PARO DE MOTOR · SEGUIMIENTO 24/7",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/rastreo_gps_poseidon.png",
    alt: "Interfaz de seguimiento satelital para flotas vehiculares"
  }, {
    number: "04",
    title: "Capacitación Especializada",
    description: "Programas de formación continua para nuestro personal en tácticas de defensa, primeros auxilios y manejo de crisis, garantizando un servicio de élite y profesionalismo.",
    techniques: "CERTIFICACIONES · DEFENSA PERSONAL · PROTOCOLOS",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/capacitacion_seguridad_poseidon.png",
    alt: "Personal de seguridad en sesión de entrenamiento táctico"
  }, {
    number: "05",
    title: "Seguridad Electrónica",
    description: "Diseño e instalación de sistemas integrales que incluyen alarmas, sensores de movimiento y controles biométricos adaptados a las necesidades específicas de su infraestructura.",
    techniques: "BIOMETRÍA · SENSORES · ALARMAS INTELIGENTES",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/seguridad_electronica_poseidon.png",
    alt: "Instalación de panel de control de acceso biométrico"
  }, {
    number: "06",
    title: "Consultoría en Riesgos",
    description: "Análisis exhaustivo de vulnerabilidades para diseñar estrategias de protección a medida. Evaluamos cada entorno para mitigar amenazas antes de que se conviertan en problemas.",
    techniques: "AUDITORÍA · ANÁLISIS DE RIESGO · ESTRATEGIA",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/consultoria_riesgos_poseidon.png",
    alt: "Especialista analizando planos de seguridad corporativa"
  }];
  return <section data-section-id="3587" id="soluciones-de-seguridad-integral" className="bg-background text-foreground py-20 md:py-28 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`max-w-4xl transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm uppercase tracking-widest text-muted-foreground">
            Nuestras Soluciones &mdash; 02
          </p>
          <h2 className="font-default mt-6 md:mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.1] tracking-tighter text-foreground">
            <span className="font-light">Protección</span> estratégica,
            <br />
            tecnología de vanguardia.
          </h2>
        </div>

        {}
        <div className="mt-20 md:mt-24 lg:mt-28 grid grid-cols-1 md:grid-cols-2 md:gap-x-16 lg:gap-x-24">
          {services.map((service, i) => {
          const isLastRow = i >= services.length - (services.length % 2 === 0 ? 2 : 1);
          return <ServiceBlock key={service.number} data-index={i} service={service} index={i} isLastRow={isLastRow} />;
        })}
        </div>
      </div>
    </section>;
}
type ServiceProps = {
  service: {
    number: string;
    title: string;
    description: string;
    techniques: string;
    image: string;
    alt: string;
  };
  index: number;
  isLastRow: boolean;
  "data-index"?: number;
};
function ServiceBlock({
  service,
  index,
  isLastRow,
  ...rest
}: ServiceProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={rest["data-index"]} className={`relative pt-12 md:pt-16 lg:pt-20 ${isLastRow ? "pb-0" : "pb-12 md:pb-16 lg:pb-20"} border-t border-border transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    transitionDelay: `${index % 2 * 100}ms`
  }}>
      <div className="grid grid-cols-[auto_1fr] gap-x-5 md:gap-x-7">
        {}
        <div className="font-mono font-light leading-none text-[64px] md:text-[72px] lg:text-[80px] select-none opacity-10" style={{
        color: "var(--chart-1)"
      }} aria-hidden="true">
          {service.number}
        </div>

        {}
        <div className="flex flex-col min-w-0">
          <h3 className="font-default text-2xl md:text-[24px] font-semibold leading-tight text-foreground">
            {service.title}
          </h3>

          <p className="mt-4 md:mt-5 text-base leading-relaxed line-clamp-3 font-default" style={{
          color: "var(--chart-3)"
        }}>
            {service.description}
          </p>

          <p className="mt-5 md:mt-6 font-mono text-[11px] md:text-xs uppercase tracking-widest text-primary font-medium">
            {service.techniques}
          </p>

          {}
          <div className="mt-8 flex justify-end">
            <div className="w-[140px] h-[140px] md:w-[160px] md:h-[160px] overflow-hidden rounded-md shadow-lg border border-border/50">
              <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.alt} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}